import { FunctionComponent } from 'react';
import { match } from 'react-router-dom';

import { renderRoutes } from 'scenes/Report/Report.helper';

import {
  MerchantMembershipMetrics,
  MerchantRevenueMetrics,
  AggregateMerchantMembershipsMetrics,
  CostcoMembershipExperimentMetrics,
  ATTMetricsBySegment,
  MerchantMetricsBySegment,
} from '.';

type Props = {
  match: match;
  whitelistReports?: string[];
};

const routes = (match: match) => [
  {
    path: `${match.url}/merchantMembershipsMetrics`,
    component: MerchantMembershipMetrics,
  },
  {
    path: `${match.url}/merchantRevenueMetrics`,
    component: MerchantRevenueMetrics,
  },
  {
    path: `${match.url}/aggregateMerchantMembershipsMetrics`,
    component: AggregateMerchantMembershipsMetrics,
  },
  {
    path: `${match.url}/costcoMembershipExperimentMetrics`,
    component: CostcoMembershipExperimentMetrics,
  },
  {
    path: `${match.url}/attMetricsBySegment`,
    component: ATTMetricsBySegment,
  },
  {
    path: `${match.url}/lyftMetricsBySegment`,
    component: MerchantMetricsBySegment,
  },
];

const CustomReportsRoutes: FunctionComponent<Props> = ({
  match,
  whitelistReports,
}) => renderRoutes(routes(match), whitelistReports);

export default CustomReportsRoutes;
